import { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import format from 'format-number';

const columns = [
  { id: 'anio', label: 'Año', width: 150, align: 'center' },
  { id: 'montoMaximoNacionalDia', label: 'Monto máximo de viáticos nacionales por día', width: 150, align: 'center' },
  { id: 'montoMaximoInternacionalDia', label: 'Monto máximo de viáticos internacionales por día', width: 150, align: 'center' },
];

export default function MontosListado(props) {

  const { idEntidad, guardado, setGuardado } = props
  const [configuraciones, setConfiguraciones] = useState([])
  const cargarConfiguraciones = async () => {
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionMontos/lista/${idEntidad}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    }

    )
    const data = await res.json()
    //console.log(`Montos en MontosLista ${JSON.stringify(data)}`)
    setConfiguraciones(data)
    setGuardado(false)
  }
 
  useEffect(() => {
    (async () => {
      await cargarConfiguraciones()
    })()
  }, [guardado])
  return (
    <Paper sx={{ width: '100%', marginTop: 5 }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow key='encabezado'>
              <TableCell key='ninguna' align="center" colSpan={7}>
                Montos de la Gestión de Presupuesto
              </TableCell>
            </TableRow>
            <TableRow key='encabezado2'>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ top: 57, minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {configuraciones && configuraciones.length > 0 ? configuraciones
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.idConfiguracionMontos}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.id === 'anio' ? value : format({ prefix: '$' })(value)}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              }) : <TableRow hover role="checkbox" tabIndex={-1} >

              <TableCell align='center'>
                No hay montos registrados este año
              </TableCell>

            </TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}